// extracted by mini-css-extract-plugin
module.exports = {"example":"monsterHunter-module--example--a6X-g"};